import React, { useState, useRef } from "react";
import { Grid } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";


// styles
import useStyles from "./styles";

// components
import Widget from "../../Components/Widget/Widget";
import PageTitle from "../../Components/PageTitle/PageTitle";
import { Typography } from "../../Components/Wrappers/Wrappers";
import BidRequestAnalyser from "../../Components/BidRequestAnalyser/BidRequestAnalyser";
const mainChartData = getMainChartData();
const PieChartData = [
  { name: "Group A", value: 400, color: "primary" },
  { name: "Group B", value: 300, color: "secondary" },
  { name: "Group C", value: 300, color: "warning" },
  { name: "Group D", value: 200, color: "success" },
];

export default function Dashboard(props) {
  var classes = useStyles();
  var theme = useTheme();
  const urlopener = useRef(null);
  const textmerger = useRef();
  const urldecoder = useRef();
  const base64decoder = useRef();
  const jsonexporter = useRef();
  const punycodetourl = useRef();
  const parameterreporter = useRef();
  const criteoblocklist = useRef();
  const domainblockingtoolconverter = useRef();

  
  var [mainChartState, setMainChartState] = useState("monthly");

  return (
    <>
    
      <PageTitle title="Bid Requests Analyser" />
    
      <br></br><br></br><br></br>
      <div ref={urlopener}></div>
      
        <Grid container spacing={4}>
  
        <Grid item xs={12}>
          
          <Widget
            title="aa"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
            
          >
           <Typography>Bid Requests Analyser</Typography>
            <BidRequestAnalyser></BidRequestAnalyser>
          </Widget>
          
        </Grid>
        
        
        
             </Grid>
  
    </>
  );
}

// #######################################################################
function getRandomData(length, min, max, multiplier = 10, maxDiff = 10) {
  var array = new Array(length).fill();
  let lastValue;

  return array.map((item, index) => {
    let randomValue = Math.floor(Math.random() * multiplier + 1);

    while (
      randomValue <= min ||
      randomValue >= max ||
      (lastValue && randomValue - lastValue > maxDiff)
    ) {
      randomValue = Math.floor(Math.random() * multiplier + 1);
    }

    lastValue = randomValue;

    return { value: randomValue };
  });
}

function getMainChartData() {
  var resultArray = [];
  var tablet = getRandomData(31, 3500, 6500, 7500, 1000);
  var desktop = getRandomData(31, 1500, 7500, 7500, 1500);
  var mobile = getRandomData(31, 1500, 7500, 7500, 1500);

  for (let i = 0; i < tablet.length; i++) {
    resultArray.push({
      tablet: tablet[i].value,
      desktop: desktop[i].value,
      mobile: mobile[i].value,
    });
  }

  return resultArray;
}
